import React, { useEffect, useRef, useState } from 'react';
import Button from '../../components/buttons/Button';

interface InputModalProps {
  closeModal: () => void;
  InputChangeHandler: (arg: string | null) => void;
}

const InputModal: React.FC<InputModalProps> = ({
  closeModal,
  InputChangeHandler,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [inputValue, setInputValue] = useState<string>('');

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        closeModal();
        InputChangeHandler(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [closeModal, InputChangeHandler]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleFormSubmit = () => {
    if (inputValue.trim()) {
      InputChangeHandler(inputValue);
      closeModal();
    }
  };

  return (
    <div
      ref={modalRef}
      className="h-fit w-[528px] rounded-[12px] border bg-white py-5"
      style={{ border: '1px solid rgba(229, 231, 235, 1)' }}
    >
      <div>
        <div className="px-4 pt-5">
          <input
            value={inputValue}
            onChange={handleInputChange}
            type="text"
            placeholder="Enter Unique ID"
            className="h-[40px] w-full rounded-lg border border-[#D1D5DB] bg-white text-center text-base font-medium text-[#4B5563] placeholder:text-[#4B5563] focus:outline-[#1C64F2]"
          />
        </div>
        <div className="my-5 px-4">
          <Button
            disabled={inputValue.trim().length <= 0}
            onClick={handleFormSubmit}
            text="Submit"
            className="leading-1 flex w-full justify-center rounded-lg bg-[#1C64F2] px-3 py-1.5 font-inter text-lg font-medium tracking-wider text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          />
        </div>
      </div>
    </div>
  );
};

export default InputModal;
